<template>
    <section class="gen-form-container">
      <form>
      <div class="gen-form-box">
        <div class="gfb-title">
          <h3>Form elements preview</h3>
          <p>All kinds of form elements</p>
        </div>
        <div class="gf-row">
          <div class="col-md-6 col-lg-4">
            <label>Simple input field</label>
            <FormInput placeholder="Input field" v-model="form.input" />
          </div>
          <div class="col-md-6 col-lg-8">
            <label>Simple input field</label>
            <FormInput placeholder="Input field" v-model="form.input" />
          </div>
        </div>
        <div class="gf-row">
          <div>
            <label>Compound field</label>
            <FormCompound>
              <label>$</label>
              <FormInput placeholder="Input field" v-model="form.input" />
              <button class="btn">Go</button>
            </FormCompound>
          </div>
        </div>
        <div class="gf-row">
          <div>
            <label>Compound field</label>
            <FormCompound>
              <FormInput placeholder="Input field" v-model="form.input" />
              <label>$</label>
              <button class="btn">Go</button>
            </FormCompound>
          </div>
        </div>
        <div class="gf-row">
          <div>
            <label>Simple password field</label>
            <FormPassword placeholder="Enter password" v-model="form.password" />
          </div>
        </div>
        <div class="gf-row">
          <div>
            <label>Simple text area</label>
            <FormText placeholder="Enter long text here" v-model="form.text" />
          </div>
        </div>
        <div class="gf-row">
          <div>
            <label>Autoresize text area</label>
            <FormTextAuto placeholder="Enter long text here" v-model="form.text" />
          </div>
        </div>
        <div class="gf-row">
          <div>
            <label>Select</label>
            <FormSelect placeholder="Select an option" v-model="form.option" :options="options" :optional="true" />
          </div>
        </div>
        <div class="gf-row">
          <div>
            <label>Multi select</label>
            <FormMultiSelect placeholder="Select an option" v-model="form.option2" :options="options" :optional="true" />
          </div>
        </div>
        <div class="gf-row">
          <div>
            <label>Simple wysiwyg</label>
            <FormWysiwyg v-model="form.text" />
          </div>
        </div>
        <div class="gf-row">
          <div>
            <label>Floating wysiwyg</label>
            <FormWysiwyg mode="inline" v-model="form.text" />
          </div>
        </div>
        <FormRepeater :variants="repeaterVariants" v-model="form.content" />
      </div>
      </form>
    </section>
</template>

<script>
export default {
  data: ()=>({
    form: {
      input: "",
      password: "",
      text: "",
      option: null,
      options2: null,
      content: [],
    },
    options: [
      {value: 1, text: "First"},
      {value: 2, text: "Second"},
    ],
    repeaterVariants: [
      {type: "wysiwyg", name: "Wysiwyg", component: "FormWysiwyg", props: {mode: "inline"}},
      {type: "text", name: "Textarea", component: "FormTextAuto"},
    ],
  }),
}
</script>
